'use client';

import { WorkspaceMobileDrawer } from '@/cms/components/blocks/workspace/workspace-1/shell/workspace-mobile-drawer';
import type {
  CmsAccountSettingsDialogProps,
  CmsAccountSettingsPresentation,
} from '@/components/account-settings/cms-account-settings-dialog';
import { CmsAccountSettingsDialogLoading } from '@/components/account-settings/cms-account-settings-dialog-loading';
import dynamic from 'next/dynamic';

const LazyCmsAccountSettingsDialogSurface =
  dynamic<CmsAccountSettingsDialogProps>(
    () =>
      import('@/components/account-settings/cms-account-settings-dialog').then(
        (module) => module.CmsAccountSettingsDialog
      ),
    {
      loading: () => <CmsAccountSettingsDialogLoading presentation="dialog" />,
      ssr: false,
    }
  );

const LazyCmsAccountSettingsDrawerSurface =
  dynamic<CmsAccountSettingsDialogProps>(
    () =>
      import('@/components/account-settings/cms-account-settings-dialog').then(
        (module) => module.CmsAccountSettingsDialog
      ),
    {
      loading: () => <CmsAccountSettingsDialogLoading presentation="drawer" />,
      ssr: false,
    }
  );

export function LazyCmsAccountSettingsDialog({
  presentation = 'dialog',
  ...props
}: CmsAccountSettingsDialogProps & {
  presentation?: CmsAccountSettingsPresentation;
}) {
  if (presentation === 'drawer') {
    return (
      <WorkspaceMobileDrawer
        bodyClassName="flex px-0! pt-0! pb-[env(safe-area-inset-bottom)]!"
        id="cms-account-settings-drawer"
        onOpenChange={props.onOpenChange}
        open={props.open}
        title={props.copy.settingsSectionTitle}
      >
        <LazyCmsAccountSettingsDrawerSurface {...props} presentation="drawer" />
      </WorkspaceMobileDrawer>
    );
  }

  return (
    <LazyCmsAccountSettingsDialogSurface {...props} presentation="dialog" />
  );
}
